import React from 'react';
import styles from './styles.css';
import { useInfoModal } from '../../hooks';

export default function TableFooterLegend({ legend }) {
	const infoOnClick = useInfoModal();
	return (
		<div className={styles.legendWrapper}>
			{legend.items.map((item) => {
				const label = <div className={`${item.checked ? '' : styles.strikeout}`}>{item.label}</div>;
				return (
					<div className={styles.itemWrapper} onClick={item.onclick} key={`raw-table-legend-${item.label}`}>
						<div className={`${styles[item.class]} ${styles.indicator}`} />
						{item.isCustomGroup ? (
							// Grey pill around the icon + name (the colour swatch stays outside),
							// matching the chart legends and the custom-group title styling.
							<span className={styles.customGroupPill}>
								<img src="/img/icons/custom-group.svg" alt="" className={styles.customGroupIcon} />
								{label}
							</span>
						) : (
							label
						)}
						{item.info ? (
							<img
								src="/dist/src/img/icons/infoSymbol.png"
								onClick={infoOnClick(item.info)}
								className={`clickable_pointer ${styles.infoIcon}`}
							/>
						) : null}
					</div>
				);
			})}
		</div>
	);
}
